module.exports = SimpleStorage;